import { TableColumn } from 'react-data-table-component';
import dayjs from 'dayjs';
import { InvestmentTableType } from '../../../Types/TablesType';

const currencyFormatter = new Intl.NumberFormat('es-CO', {
   style: 'currency',
   currency: 'COP',
   maximumFractionDigits: 0,
});

const percentageFormatter = new Intl.NumberFormat('en-US', {
   style: 'percent',
   maximumFractionDigits: 2,
});

export const tableColumnsInvestment: TableColumn<InvestmentTableType>[] = [
   {
      name: 'Fecha de operación',
      selector: (row) => dayjs(row['operationDate']).format('DD/MM/YYYY'),
      sortable: true,
      sortField: 'operation_date',
      center: true,
   },
   {
      name: 'Tipo de interés',
      selector: (row) => row['type'],
      sortable: true,
      center: true,
   },
   {
      name: 'Valor de interés',
      selector: (row) => currencyFormatter.format(parseFloat(row.value)),
      sortable: true,
      center: true,
   },
   {
      name: 'Tasa de interés',
      selector: (row) => percentageFormatter.format(parseFloat(row.rate)),
      sortable: true,
      center: true,
   },
   {
      name: 'Fecha de creación',
      selector: (row) => dayjs(row['createdAt']).format('DD/MM/YYYY'),
      sortable: true,
      sortField: 'created_at',
      center: true,
   },
];
